import { defineChain } from 'viem'

// Use PUBLIC RPCs directly. The previous setup routed every call through
// the backend proxy (https://w2usdt.com/api/v1/rpc/*) to dodge CORS, but
// (a) both Uni2 and BSC public RPCs now serve `Access-Control-Allow-Origin: *`,
// and (b) the proxy locks CORS to a single Origin which breaks mobile
// wallets — their webview / WalletConnect bridge sends Origin values that
// fail the strict check, producing "Switch network — this app doesn't
// support current network" with no way to recover. RPC URLs for chain
// definitions MUST be reachable directly from the user's wallet, not just
// from our dApp.

export const uni2Chain = defineChain({
  id: 111888,
  name: 'Uni2 Mainnet',
  nativeCurrency: {
    decimals: 18,
    name: 'Uni2',
    symbol: 'UNI2',
  },
  rpcUrls: {
    default: {
      http: ['https://rpc-eu.wer2chain.com'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Wer2scan',
      url: 'https://main.wer2scan.com',
    },
  },
})

export const bscChain = defineChain({
  id: 56,
  name: 'BNB Smart Chain',
  nativeCurrency: {
    decimals: 18,
    name: 'BNB',
    symbol: 'BNB',
  },
  rpcUrls: {
    default: {
      http: [
        'https://bsc-dataseed.binance.org',
        'https://bsc.publicnode.com',
        'https://bsc-dataseed1.defibit.io',
      ],
    },
  },
  blockExplorers: {
    default: {
      name: 'BscScan',
      url: 'https://bscscan.com',
    },
  },
})

export const chains = [uni2Chain, bscChain] as const
